<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Dente supranumerário"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.local"
                        label="Local"
                        v-model="model.local"
                    />
                </rkm-col>
            </rkm-row>

            <BoxProcedimento :data="{additionals: data.additionals, model}" />

            <rkm-row class="mt-2">
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="6"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxProcedimento from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/odontograma/components/procedimento/Index'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {BoxProcedimento},
    computed: {
        validations() {
            return {
                local: {
                    required: true,
                    max: 100,
                },
                observacao: {max: 5000},
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            local: null,
            procedimentos: [],
            observacao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                local: this.item.local,
                procedimentos: this.item.procedimentos,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.getDentesSupranumerarios().push(this.prepareData())
        },
        update() {
            Object.assign(this.item, this.prepareData())
        },
        prepareData() {
            return {
                local: this.model.local,
                procedimentos: this.model.procedimentos,
                observacao: this.model.observacao,
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.procedimentos.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É necessário incluir ao menos um procedimento.'
                        })

                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.local = null
            this.model.procedimentos = []
            this.model.observacao = null
        },
        getDentesSupranumerarios() {
            return this.data.model.saudeBucal.odontograma.dentesSupranumerarios
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>